import httpClient from '../../api/axios-httpclient';
import ConnectInvoiceAPI from '@/api/ConnectInvoiceAPI.js';
import commonFunc from '@/common/commonFunction';
import { MSEnum } from '../../common/enumeration';
import DownloadAPI from '../../api/DownloadAPI';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';

export default {
	/**
	 * Lấy danh sách lịch sử nhận hóa đơn tự động
	 */
	loadConnectInvoices: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/v2`,
				data: payload
			},
			false
		);
		if (res && res.Success && res.Data) {
			if (payload && payload.isTaxaxion) {
				context.commit('updateConnectInvoicesTaxaxion', res.Data);
			} else {
				context.commit('updateConnectInvoices', res.Data);
			}
		}
		return null;
	},

	/**
	 * Lấy danh sách lịch sử tự động tải hóa đơn đầu ra
	 */
	loadConnectOutputInvoices: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/v2/output`,
				data: payload
			},
			false
		);
		if (res && res.Success && res.Data) {
			context.commit('updateConnectOutputInvoices', res.Data);
		}
		return null;
	},

	/**
	 * Lấy danh sách hóa đơn đang tải (hóa đơn đầu ra)
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	loadOutInvoicePendingList: async function(context, payload) {
		context.commit('updateIsLoadingOutInvoicePending', true);
		const res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/output/pending`,
				data: { ...payload, IsOutbot: true }
			},
			false
		);
		context.commit('updateOutInvoicePendingList', res);
		context.commit('updateIsLoadingOutInvoicePending', false);
		return res;
	},

	/**
	 * Lấy tổng số bản ghi danh sách hóa đơn đang tải (hóa đơn đầu ra)
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalOutInvoicePendingAsync: async function(context, payload) {
		const res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/output/pending/total`,
				data: { ...payload, IsOutbot: true }
			},
			false
		);
		context.commit('updateOutInvoicePendingTotal', res);
		return res;
	},

	/**
	 * Chức năng tải lại trên grid hóa đơn đang tải (hóa đơn đầu ra)
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	reloadOutInvoicePendingRow: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/output/pending/sync-again`,
				data: payload
			},
			true
		);
	},

	/**
	 * Set lại dữ liệu thi chuyển sang màn hình khác
	 * @param {*} context
	 */
	resetOutInvoicePendingList(context) {
		context.commit('resetOutInvoicePendingList');
	},

	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
			data: payload
		});

		if (res && res.Success) {
			if (payload && payload.isTaxaxion) {
				context.commit('updateConnectInvoicesTaxaxionTotal', res.Data);
			} else {
				context.commit('updateConnectInvoicesTotal', res.Data);
			}
		}
		return 0;
	},
	getTotalPageOutbotAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/outinvoice/total`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateConnectOutInvoicesTotal', res.Data);
		}
		return 0;
	},
	getReconcilePeriodConfig: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/reconcileperiodconfig`
			},
			false
		);
		return res;
	},
	insertConnectInvoice: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
			data: payload
		});
		return res.Data;
	},
	//Kết nối đến nhà cung cấp hóa đơn
	connectInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/login`,
				data: payload
			},
			true
		);
		return res;
	},
	//Kết nối đến nhà cung cấp hóa đơn V2
	connectInvoiceV2: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/login`,
				data: payload
			},
			false
		);
		return res;
	},
	//Kết nối đến cơ quan thuế
	connectInvoiceTaxaxion: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/login-taxaxion`,
				data: payload
			},
			true
		);
		return res;
	},
	//Cập nhật thông tin kết nối hóa đơn NCC
	updateConnectInvoiceTaxaxion: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/update-connect-taxaxion`,
				data: payload
			},
			true
		);
		return res;
	},
	//Hủy kết nối đến nhà cung cấp hóa đơn
	unConnectInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/unconnect`,
				data: payload
			},
			true
		);
		return res;
	},
	createConnectInvoiceUser: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/createuser`,
				data: payload
			},
			true
		);
		return res;
	},
	/**
	 * Lấy thông tin đã kết nối của đơn vị này
	 */
	getConnectInfo: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/connectinfo`,
				params: payload
			},
			false,
			false
		);
		return res;
	},
	/**
	 * Lấy thông tin của danh sách chi nhánh
	 */
	getConnectInfoWithOrgCustom: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/connectinfolist`,
				data: payload
			},
			true
		);
		return res;
	},
	/**
	 * Lấy thông báo về tự động tải hóa đơn hôm nay
	 */
	getNotifiAutoDownload: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/noti`,
			params: payload
		});
		return res;
	},

	/**
	 * Lấy danh sách hóa đơn tự động tải
	 */
	getInvoicesAutoLoad: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/details/${payload}`
			},
			true
		);
		if (res && res.Success && res.Data) {
			context.commit('updateInvoicesAutoLoad', res.Data);
		}
		return null;
	},

	/**
	 * Tải lại hóa đơn của các ncc
	 */
	refreshConnect: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/refresh`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Kiểm tra xem đã có tài khoản kết nối ncc hoặc có lịch sử tải hóa đơn tự động
	 */
	checkExistConnect: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/existconnect`,
			params: payload
		});
		return res;
	},

	/**
	 * Tải lại hóa đơn của cqt trong ngày
	 */
	downloadAgainInvoicesTaxaxion: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/refreshtaxaxion`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Đồng bộ ngay dữ liệu cơ quan thuế theo khoảng ngày
	 */
	syncTaxaxionByRange: async function(context, payload) {
		if (payload) {
			payload.IsWebsiteClient = true;
		}
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/synctaxaxionbyrange`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Đối chiếu số liệu hóa đơn
	 */
	compareInvoiceQuantityAsync: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/comparequantity`,
				data: payload
			},
			true
		);
	},
	getReconcilePeriodConfig: async function(context, payload) {
		return await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/reconcileperiodconfig`
			},
			false
		);
		return res;
	},
	createReconcileSession: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/create-reconcile-session`,
				data: { FromDate: payload.FromDate, ToDate: payload.ToDate }
			},
			true
		);
	},
	checkCondition: async function(context, payload) {
		return await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/checkcondition`
			},
			true
		);
	},

	/**
	 * Đồng bộ ngay hóa đơn CQT bằng tool
	 */
	syncTaxaxionByTool: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/synctaxaxionbytool`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Đồng bộ ngay dữ liệu kết nối NCC theo khoảng ngày
	 */
	syncSupplierByRange: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/syncsupplierbyrange`,
				data: payload
			},
			true
		);
	},

	/**
	 * Đồng bộ ngay dữ liệu cơ quan thuế theo khoảng ngày
	 */
	syncTaxaxionByRangeWithOrg: async function(context, payload) {
		if (payload) {
			payload.IsWebsiteClient = true;
		}
		let res = await httpClient.postAsync(
			{
				url:
					ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly() + `/${payload.orgId}`) +
					`/synctaxaxionbyrange`,
				data: payload.payload
			},
			true
		);
		return res;
	},

	/**
	 * Đồng bộ ngay dữ liệu kết nối NCC theo khoảng ngày
	 */
	syncSupplierByRangeWithOrg: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url:
					ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly() + `/${payload.orgId}`) +
					`/syncsupplierbyrange`,
				data: payload.payload
			},
			true
		);
		return res;
	},

	/**
	 * Check hóa đơn đã có dữ liệu hóa đơn tự động tải hoặc đã kết nối
	 */
	getHistoryAutoAndIsConnect: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/checkdata`,
				params: payload
			},
			true,
			false
		);

		if (res && res.Data) {
			context.commit('updateNumberInvoiceAutoRespone', res.Data);
		}
		return res;
	},

	/**
	 * Lấy tổng số lượng hóa đơn đầu ra và hóa đơn đầu vào đã tự động tải
	 */
	getNumberInvoiceAuto: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/getnumberinvoice`,
				params: payload
			},
			false
		);
		return res;
	},

	/**
	 * Kết nối ngắt kết nối tự động tải hóa đơn từ cqt
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	connectAndUnconnectAutoInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/connect-autoload`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Lấy danh sách hóa đơn đầu ra tự động tải
	 */
	getOutInvoicesAutoLoad: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/outdetails/${payload}`
			},
			true
		);
		if (res && res.Success && res.Data) {
			context.commit('updateOutInvoicesAutoLoad', res.Data);
		}
		return null;
	},

	/**
	 * Tải lại hóa đơn đầu ra của cqt trong ngày
	 */
	downloadAgainOutInvoicesTaxaxion: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/refreshouttaxaxion`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Tải ngay hóa đơn đầu vào
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	reloadNowInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/reloadnow`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Tải ngay hóa đơn đầu ra
	 * @param {} context
	 * @param {*} payload
	 * @returns
	 */
	reloadNowOutInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/reloadnowoutinvoice`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Lấy giá trị master lịch sử tải hóa đơn đầu vào tự động
	 */
	getMaster: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/getmaster/${payload.MasterId}`
			},
			true
		);
		return res;
	},

	/**
	 * Lấy giá trị master lịch sử tải hóa đơn đầu ra tự động
	 */
	getOutMaster: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/getoutmaster/${payload.MasterId}`
			},
			true
		);
		return res;
	},

	getPagingHistoryAutoLoadInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/connectinvoicedetails`,
				data: payload
			},
			true
		);
		if (res && res.Data && res.Data.Data) {
			context.commit('updateConnectInvoiceDetails', res.Data.Data);
			return res.Data.Data;
		}
		return res;
	},

	getPagingHistoryAutoLoadOutInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/connectoutinvoicedetails`,
				data: payload
			},
			true
		);

		if (res && res.Data && res.Data.Data) {
			context.commit('updateConnectOutInvoiceDetails', res.Data.Data);
			return res.Data.Data;
		}
		return res;
	},

	getTotalInvoiceStatus: async function(context, payload) {
		if (!payload) payload = {};
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/totalstatusinvoice`,
				data: payload
			},
			true
		);

		if (res && res.Data) {
			context.commit('updateTotalInvoiceStatus', res.Data);
		}
		return res;
	},

	getTotalTypeInvoice: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/totaltypeinvoice`,
			data: payload
		});
		if (res && res.Data) {
			context.commit('updateTotalTypeInvoice', res.Data);
		}
		return res;
	},

	exportExcelConnectInvoice: async function(context, payload) {
		let fileName = 'Danh_sach_hoa_don_dau_vao_tai_tu_CQT.xlsx';
		if (!payload.IsInvoiceBot) fileName = 'Danh_sach_hoa_don_dau_ra_tai_tu_CQT.xlsx';
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportconnectinvoice',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	/**
	 * Gửi email cảnh báo
	 */
	sendEmailNotificationTaxaxationDisconnect: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/sendmaildisconnect`,
				params: payload
			},
			false
		);
		return res;
	},

	getTimeServerRemind: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/timeserverremind`,
			params: payload
		});
		if (res && res.Data) {
			context.commit('updateTimeServerRemind', res.Data);
		}
		return res;
	},

	/**
	 * Đồng bộ lại từ CQT, từng hóa đơn một
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	syncAgain: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/sync-again`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Đồng bộ lại từ CQT, thực hiện hàng loạt nhiều hóa đơn
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	syncAgainListInvoices: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/sync-again-list`,
				data: payload,
				timeout: window.__env.appSetting.timeoutSyncAgain
			},
			true
		);
		return res;
	},

	/**
	 * Lấy danh sách hóa đơn đang tải từ CQT theo khoảng ngày + phân trang (không gồm tổng số).
	 * PBI 625836 — tab "Hóa đơn đang tải".
	 * @param payload {FromDate, ToDate, Skip, Take}
	 */
	loadInvoiceLoadingList: async function(context, payload) {
		context.commit('updateIsLoadingInvoiceLoading', true);
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/pending`,
				data: payload
			},
			false
		);
		if (res && res.Success && res.Data) {
			context.commit('updateInvoiceLoadingList', res);
		} else {
			context.commit('updateInvoiceLoadingList', null);
		}
		context.commit('updateIsLoadingInvoiceLoading', false);
		return res;
	},

	/**
	 * Lấy tổng số hóa đơn đang tải theo khoảng ngày, phục vụ phân trang.
	 * @param payload {FromDate, ToDate}
	 */
	getTotalInvoiceLoadingAsync: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/pending/total`,
				data: payload
			},
			false
		);
		context.commit('updateInvoiceLoadingTotal', res && res.Success ? res.Data : 0);
		return res;
	},

	/**
	 * Tải lại 1 dòng hóa đơn đang tải từ CQT (icon Tải lại trên dòng lỗi).
	 * Spec 625836: chỉ áp dụng dòng Tải thất bại / Bỏ qua, không cần xác nhận.
	 * Dùng endpoint riêng /pending/sync-again (không chặn theo InvoiceId/Series như sync-again chung).
	 * @param payload {SellerTaxCode, TemplateNo, Series, InvoiceNo, InvoiceId, IsInbot}
	 */
	reloadInvoiceLoadingRow: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ConnectInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/pending/sync-again`,
				data: payload
			},
			true
		);
		return res;
	}
};
